// extracted by mini-css-extract-plugin
module.exports = {"stageBlock":"styles_stageBlock___c8GC","stageActive":"styles_stageActive__DGs40"};